import * as React from 'react';

import * as cs from './Honeypot.module.css';

interface Props {
  name: string;
  type: 'list' | 'post' | 'footer' | 'contact';
}

export const Honeypot = ({ name, type }: Props) => {
  return (
    <label className={cs.ohnohoney} aria-hidden>
      {/* eslint-disable-next-line jsx-a11y/autocomplete-valid */}
      <input
        autoComplete="nope"
        type="text"
        name={name}
        id={`${name}_${type}`}
        placeholder={`Your ${name}`}
        aria-label={`Your ${name}`}
        tabIndex={-1}
        aria-hidden
      />
    </label>
  );
};
